const palette = {
    primary: {
        normal: "#001EFF",
        hover: "#0018CC"
    },
    secondary: {
        normal: "#000000",
        hover: "#FFFFFF"
    },
    error: {},
    warning: {},
    info: {},
    success: {},
    mo: {
        charcoal: "#151515"
    }
};

export default palette;